import React, { JSX } from 'react';
import { Helmet } from 'react-helmet';
import { MINI_GROUP_STR_DE, SMALL_GROUP_STR_DE } from '../../Util/constant';

const CanonicalHead = (): JSX.Element => {
  const getCanonicalUrl = (): string => {
    const url = new URL(window.location.href);
    url.searchParams.delete(SMALL_GROUP_STR_DE);
    url.searchParams.delete(MINI_GROUP_STR_DE);
    return url.origin + url.pathname + (url.search ? url.search : '');
  };

  return (
    <Helmet>
      <link rel="canonical" href={getCanonicalUrl()} />
    </Helmet>
  );
};

export default CanonicalHead;
